import { useState } from "react";
import { HistoryBox } from "../../styles/BoxingStyles";
import {DText, FlexCenter, GlobalLoadingWrapper, IconWrapper} from "../../styles/CommonStyles";
import {HistoryBody, OrdersBody, OrdersTab} from "../../styles/OrdersStyle";
import Text from "../../utils/Text";
import CurrentOrders from "./CurrentOrders";
import History from "./History";
import {PuffLoader} from "react-spinners";
import {useMainContext} from "../../contexts/main";
import {useWindowSize} from "../../hooks/common/useWindowSize";
import {TABLET_SIZE} from "../../constants/common";
import RCurrentOrders from "../responsive/RCurrentOrders";
import {HOME} from "../../constants/urls";
import RHistory from "../responsive/RHistory";
import {Flex} from "../../styles/MarketStyles";
import FilterLayout from "../../layouts/filter/FilterLayout";
import {useMyOrdersQuery, useOrdersHistoryQuery} from "../../services/react-query/useOrdersQuery";
import {
    CacheKeys,
    orderFilterOptions,
    orderSortOptions,
    tradeFilterOptions,
    tradeSortOptions
} from "../../constants/filter";
import {RefreshIcon} from "../../styles/dashboard";
import {useFilterContext} from "../../contexts/filter";


const OrdersHistory = () => {

    const {_loading, profile: {token}} = useMainContext()
    const { width } = useWindowSize()
    const { pagination, cache, setPagination } = useFilterContext()

    const [activeTab, setActiveTab] = useState(0)
    const initialState = { data: null, loading: true }
    const [trades, setTrades] = useState(initialState)
    const [orders, setOrders] = useState(initialState)

    const onTabClicked = (idx) => {
        if (idx !== activeTab) {
            setActiveTab(idx)
        }
    }

    const goToRegister = () => {
        window.location.href = HOME + "user/register-signin"
    }

    const refreshQuery = () => {
        const _pagination = pagination[cache]
        setPagination({..._pagination, page: 1})
    }

    return (
        <HistoryBox>
            <Flex fw justify={'space-between'} height={ width > TABLET_SIZE ? '80px' : '50px' }>
                <Flex fh>
                    {tabs.map((tab, idx) => (
                        <OrdersTab
                            active={activeTab === idx}
                            onClick={() => onTabClicked(idx)}
                            key={tab}
                            id={`tour-${tab}`}
                        >
                            <DText><Text tid={tab} /></DText>
                        </OrdersTab>
                    ))}
                </Flex>
                <IconWrapper style={{ margin: '0 10px' }} onClick={refreshQuery}>
                    <RefreshIcon size={18}/>
                </IconWrapper>
            </Flex>

            <HistoryBody>
                { !!token ?
                    <OrdersBody>
                        {activeTab === 0 && (
                            <FilterLayout
                                query={useMyOrdersQuery}
                                cache={CacheKeys.ORDER}
                                options={orderFilterOptions}
                                sortOptions={orderSortOptions}
                                onQuerySuccess={(res) => setOrders(res)}
                            >
                                {width > TABLET_SIZE ?
                                    <CurrentOrders data={orders} />
                                    :
                                    <RCurrentOrders data={orders} />
                                }
                            </FilterLayout>
                        )}
                        { activeTab === 1 &&
                            <FilterLayout
                                query={useOrdersHistoryQuery}
                                options={tradeFilterOptions}
                                onQuerySuccess={(res) => setTrades(res)}
                                cache={CacheKeys.TRADE}
                                sortOptions={tradeSortOptions}
                            >
                                {width > TABLET_SIZE ?
                                    <History data={trades} />
                                    :
                                    <RHistory data={trades} />
                                }
                            </FilterLayout>
                        }
                    </OrdersBody>
                    :
                    <Flex fw height={'300px'}>
                        <Flex onClick={goToRegister} style={{ cursor: 'pointer' }}>
                            <DText fontSize="1rem" color="#599eff"><Text tid="signin" />/</DText>
                            <DText fontSize="1rem" color="#599eff"><Text tid="register" /></DText>
                        </Flex>
                    </Flex>
                }



                {_loading &&
                    <GlobalLoadingWrapper>
                        <PuffLoader size={24} color="#599eff" />
                    </GlobalLoadingWrapper>
                }
            </HistoryBody>

        </HistoryBox>
    )
}

const tabs = ["current-orders", "orders-history"]

export default OrdersHistory;
